<template>
    <div>
        <el-card class="box-card">
            <el-form :model="opinion" ref="searchRef" label-width="70px">
                <el-form-item label="意见" class="addAdminForm">
                    <el-input type="textarea" v-model="opinion.suggestion" placeholder="" rows="15"></el-input>
                </el-form-item>
                <el-form-item label="处理结果" class="addAdminForm">
                    <el-input type="textarea" v-model="opinion.reply" placeholder="请输入处理结果" rows="15"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="clicksave">提交</el-button>
                    <el-button type="info" @click="backFeedback">返回</el-button>
                </el-form-item>
            </el-form>

        </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      opinion: {
        suggestion: '',
        reply: ''
      },
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.opinion.suggestion = this.parentdata.params.suggestion
      this.opinion.reply = this.parentdata.params.reply
    },
    backFeedback () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditFeedback()
    },
    apiEditFeedback: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        feedbackid: that.parentdata.params.feedbackid,
        reply: that.opinion.reply
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditFeedback, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
